import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  ID: {
    translation: {
      welcome: "Selamat datang di Hotel Ku",
      bookNow: "Pesan Sekarang",
      home: "Beranda",
      aboutUs: "Tentang Kami",
      tours: "Tur",
      destination: "Destinasi",
      gallery: "Galeri",
      contact: "Kontak",
      login: "Masuk",
      register: "Daftar",
      noAccount: "Belum punya akun?",
      email: "Email",
      password: "Kata Sandi",
      enterEmail: "Masukkan email Anda",
      enterPassword: "Masukkan kata sandi Anda",
      register: "Daftar",
      fullName: "Nama Lengkap",
      enterFullName: "Masukkan nama lengkap Anda",
      confirmPassword: "Konfirmasi Kata Sandi",
      confirmYourPassword: "Masukkan ulang kata sandi Anda",
      alreadyHaveAccount: "Sudah punya akun?",
      passwordMismatch: "Kata sandi tidak cocok!",
      registerSuccess: "Pendaftaran berhasil! Silakan login.",
      facilities: "Fasilitas",
      swimmingPool: "Kolam Renang",
      blog: "Blog",
      gathering: "Gathering",
      perNight: "Malam",
      guest: "Tamu",
      checkAvailability: "Cek Ketersediaan",
      roomType: "Tipe Kamar",
      numberOfGuest: "Jumlah Tamu",
      todayPrice: "Harga Hari ini",
      yourSelection: "Pilihan Anda",
      selectionRoom: "Pilih Kamar",
      seeAllPhotos: "Lihat semua foto",
      enterGuestDetail: "Masukkan Detail Tamu",
      edit: "Ubah",
      specialRequests: "Permintaan Khusus",
      selectPreferences: "Pilih Preferensi",
      customerInformation: "Infomasi Customer",
      paymentInformation: "Informasi Pembayaran",
      bookingConfirmed: "Konfirmasi Booking",
      yourStay: "Masa Menginap Anda",
      priceHoldMessage: "Kami sedang mungunci harga untuk Anda...",
      next: "Selanjutnya",
      back: "Kembali",
      totalPrice: "Total Harga",
      taxes: "(termasuk pajak & biaya)",
      manualPaymentDetails: "Detail Pembayaran Manual",
      uploadTransferProof: "Upload Bukti Transfer",
      manualTransfer: "Transfer Manual",
      automaticPaymentDetails: "Detail Pembayaran Otomatis",
      automaticPaymentDescription:
        "Biaya layanan akan dibebankan otomatis kepada pengguna sesuai metode pembayaran yang dipilih",
      manualTransferDescription:
        "Transaksi akan diproses setelah mendapat persetujuan dari pihak hotel. Mohon tunggu konfirmasi sebelum melanjutkan.",
      cancel: "Batal",
      paymentNow: "Bayar Sekarang",
      automaticPayment: "Pembayaran Otomatis",
      selectPaymentMethod: "Pilih Metode Pembayaran",
      bookingDetails: "Detail Pemesanan",
      bookMore: " Pesan Lagi",
      checkIn: "Check In",
      checkOut: "Check Out",
      subTotal: "Subtotal",
      byBookingYouAgree: "Dengan melakukan pemesanan, Anda setuju",
      terms: "Syarat & Ketentuan",
      paymentTerms: "Ketentuan Pembayaran",
      total: "Total",
      breakfast: "Sarapan",
      notesLabel: "Catatan Khusus",
      notesPlaceholder: "Catatan Khusus",
      room: "Kamar",
      galleryDescription: "Jelajahi galeri indah kami.",
      ourAccommodation: "Menginap di akomodasi unik terpopuler kami",
      descriptionAccommodation:
        "Dari kastel dan vila hingga perahu dan iglo, kami menawarkan berbagai pilihan yang lengkap.",
      getInTouch: "Hubungi Kami",
      sendMessage: "Kirim Pesan",
      phoneNumber: "No Telpon",
      message: "Pesan",
      yourEmail: "Masukkan Email Anda",
      yourNumber: "Masukkan No Telpon Anda",
      placeholderMessage: "Beritahu kami apa yang dapat kami bantu",
      descriptionPromos: "Jangan sampai kelewatan promo akomodasi ini!",
      upcoming: "Pemesanan Mendatang",
      completed: "Selesai",
      cancelled: "Dibatalkan",
      startPlanning: "Mulailah merencanakan perjalanan berikutnya!",
      trips: "perjalanan",
      youHave: "Anda belum memiliki",
      myBooking: "Pemesanan Saya",
      statusBooking: "Status Pesanan",
      roomType: "Tipe Kamar",
      favorite: "Favorit",
      activities: "Aktifitas",
      rating: "Ulasan",
      yourActivities: "Aktifitas Anda",
      noReservation: "Tidak ada data reservasi ditemukan",
      payment: "Pembayaran",
      overview: "Ringkasan",
      roomDetail: "Informasi Kamar",
      guestInfo: "Informasi Tamu",
      note: "Catatan",
      guestName: "Nama Tamu",
      paymentMethod: "Metode Pembayaran",
      amountPaid: "Jumlah Bayar",
      date: "Tanggal",
      readMore: "Baca Selengkapnya",
      confirmationTitle: "Konfirmasi Pemesanan",
      confirmationMessage:
        "Terima kasih atas pemesanan Anda! Reservasi Anda telah dikonfirmasi",
    },
    confirmationDetail:
      "Email konfirmasi telah dikirim ke alamat email yang terdaftar",
    bookingReference: "Referensi Pesanan",
    goToHome: "Kembali ke Beranda",
    totalPayment: "Total Pembayaran",
    review: "Ulasan",
    giveARating: "Beri Penilaian",
    writeAReview: "Buat Ulasan",
    writeYourExperience: "Ceritakan Pengalaman Anda",
    termsAndConditions: "Syarat Dan Ketentuan",
    paymentTermsTitle: "Syarat dan Ketentuan Pembayaran",
    agreementTermCondition:
      "Harap baca dan setujui Syarat & Ketentuan serta Kebijakan Pembayaran sebelum melanjutkan.",
    reservationSuccessful: "Reservasi berhasil",
    processingReservation: "Proses Reservasi",
    notifications: "Notifikasi",
    noNotifications: "Tidak ada notifikasi",
    noAccommodations: "Tidak ada akomodasi yang tersedia",
  },
  EN: {
    translation: {
      welcome: "Welcome to Hotel Ku",
      bookNow: "Book Now",
      home: "Home",
      aboutUs: "About Us",
      tours: "Tours",
      destination: "Destination",
      gallery: "Gallery",
      contact: "Contact",
      login: "Login",
      register: "Register",
      noAccount: "Don't have an account?",
      email: "Email",
      password: "Password",
      enterEmail: "Enter your email",
      enterPassword: "Enter your password",
      register: "Register",
      fullName: "Full Name",
      enterFullName: "Enter your full name",
      confirmPassword: "Confirm Password",
      confirmYourPassword: "Re-enter your password",
      alreadyHaveAccount: "Already have an account?",
      passwordMismatch: "Passwords do not match!",
      registerSuccess: "Registration successful! Please login.",
      facilities: "Facilities",
      swimmingPool: "Swimming Pool",
      blog: "Blog",
      gathering: "Gathering",
      perNight: "Night",
      guest: "Guest",
      checkAvailability: "Check Availability",
      roomType: "Room Type",
      numberOfGuest: "Number Of Guest",
      todayPrice: "Today's Price",
      yourSelection: "Your Selection",
      selectionRoom: "Selection Room",
      seeAllPhotos: "See all photos",
      enterGuestDetail: "Enter Guest Detail",
      edit: "Edit",
      specialRequests: "Special Requests",
      selectPreferences: "Select Preferences",
      customerInformation: "Customer Information",
      paymentInformation: "Payment Information",
      bookingConfirmed: "Booking Confirmed",
      yourStay: "Your Stay",
      priceHoldMessage: " We are holding your price...",
      next: "Next",
      back: "Back",
      totalPrice: "Total Price",
      taxes: "(taxes & fees included)",
      manualPaymentDetails: "Manual Payment Details",
      uploadTransferProof: "Upload Transfer Proof",
      manualTransfer: "Manual Transfer",
      automaticPaymentDetails: "Automatic Payment Details",
      automaticPaymentDescription:
        "The service fee will be automatically charged to the user based on the selected payment method",
      manualTransferDescription:
        "The transaction will be processed upon approval from the hotel. Please wait for confirmation before proceeding",
      cancel: "Cancel",
      paymentNow: "Payment Now",
      automaticPayment: "Automatic Payment",
      selectPaymentMethod: "Select Payment Method",
      bookingDetails: "Booking Details",
      bookMore: " Book More",
      checkIn: "Check In",
      checkOut: "Check Out",
      subTotal: "Subtotal",
      byBookingYouAgree: "By booking, you have agreed to our",
      terms: "Terms & Conditions",
      paymentTerms: "Payment Terms",
      total: "Total",
      breakfast: "Breakfast",
      notesLabel: "Special Requests",
      notesPlaceholder: "Special Requests",
      room: "Room",
      galleryDescription: "Explore our beautiful gallery",
      ourAccommodation: "Our Top Unique Accommodations",
      descriptionAccommodation:
        "From castles and villas to boats and igloos, we offer a wide range of complete options",
      getInTouch: "Get in touch",
      sendMessage: "Send Messge",
      phoneNumber: "Phone Number",
      message: "Message",
      yourEmail: "Enter Your Email",
      yourNumber: "Enter Your phone Number",
      placeholderMessage: "Tell us what we can help you with",
      descriptionPromos: "Don't miss out on this accommodation promo!",
      upcoming: "Upcoming",
      completed: "Completed",
      cancelled: "Cancelled",
      startPlanning: "Start planning your next trip?",
      trips: "trips",
      youHave: "you have",
      myBooking: "My Bookings",
      statusBooking: "Booking Status",
      roomType: "Room Types",
      favorite: "Favorite",
      activities: "Activities",
      rating: "Rating",
      yourActivities: "Your Activities",
      noReservation: "No reservations found",
      payment: "Payment",
      overview: "Overview",
      roomDetail: "Room Detail",
      guestInfo: "Guest Info",
      note: "Notes",
      guestName: "Guest Name",
      paymentMethod: "Payment Method",
      amountPaid: "Amount Paid",
      date: "Date",
      readMore: "Read More",
      confirmationTitle: "Booking Confirmation",
      confirmationMessage:
        "Thank you for your booking! Your reservation has been confirmed.",
      confirmationDetail:
        "A confirmation email has been sent to your registered email ",
      bookingReference: "Booking Reference",
      goToHome: "Go To Home",
      totalPayment: "Total Payment",

      reviews: "Reviews",
      giveARating: "Give A Rating",
      writeAReview: "Write A Review",
      writeYourExperience: "Write Your Experience",
      termsAndConditions: "Terms And Condition",
      paymentTermsTitle: "Terms and Conditions of Payment",
      agreementTermCondition:
        "Please read and agree to the Terms & Conditions and Payment Policy before proceeding.",
      reservationSuccessful: "Reservation Successfully",
      processingReservation: "Processing Reservation",
      notifications: "Notifications",
      noNotifications: "No notifications available",
      noAccommodations: "No accommodations available",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("language") || "ID",
  fallbackLng: "ID",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
